import React from "react";
import MySwiper from "./MySwiper";

const Gallery = ({ commonData, clientData, gallerydata }) => (
  <div
    className="gallery"
    id={
      clientData.gallerySlug ? clientData.gallerySlug : commonData.gallerySlug
    }
  >
    <div className="section-title">{commonData.gallerySectionHeading}</div>
    <MySwiper swiperdata={gallerydata} />
  </div>
);

export default Gallery;
